import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';

const AdminMenu = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    navigate('/admin-login');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-xl mx-auto bg-white p-6 rounded-lg shadow-md space-y-6">
        <h1 className="text-2xl font-bold text-center">Panel de Administración</h1>

        <div className="space-y-3">
          <Button className="w-full" onClick={() => navigate('/registro-mozo')}>
            📋 Registrar Mozo
          </Button>
          <Button className="w-full" onClick={() => navigate('/admin-productos')}>
            📦 Administrar Productos
          </Button>
          <Button className="w-full" onClick={() => navigate('/admin-categorias')}>
            📁 Administrar Categorías
          </Button>
          <Button className="w-full" onClick={() => navigate('/registro-descuento')}>
            🎟️ Registrar Descuento
          </Button>
          <Button className="w-full" onClick={() => navigate('/admin-promociones')}>
            🎯 Promociones
          </Button>
          <Button className="w-full" onClick={() => navigate('/admin-liquidacion')}>
            💰 Liquidación Propinas
          </Button>
          <Button className="w-full" onClick={() => navigate('/admin-proveedores')}>
            🧾 Proveedores
          </Button>
          <Button className="w-full" onClick={() => navigate('/admin-flujo-caja')}>
            📊 Flujo de caja
          </Button>
          <Button className="w-full" onClick={() => navigate('/admin-turno-caja')}>
            ⏱️ Turno de caja
          </Button>
          <Button className="w-full" onClick={() => navigate('/admin-compras')}>
            🛒 Compra
          </Button>
          <Button className="w-full" onClick={() => navigate('/admin-esquemas')}>
  📊 Esquemas
</Button>
<Button className="w-full" onClick={() => navigate('/admin-cotizaciones')}>
  💱 Cotizaciones
</Button>
<Button className="w-full" onClick={() => navigate('/admin-gastos')}>
  🧾 Gastos
</Button>
<Button className="w-full" onClick={() => navigate('/admin-stock')}>
  🧮 Stock mínimo
</Button>



        </div>

        <hr />

        <Button
          variant="destructive"
          className="w-full"
          onClick={handleLogout}
        >
          🚪 Cerrar Sesión
        </Button>
      </div>
    </div>
  );
};

export default AdminMenu;
